import React from 'react';

type Props = {
  children: React.ReactNode;
};

export default function LayoutDefault({ children }: Props) {
  return <React.Fragment>{children}</React.Fragment>;
}
